import React from 'react';
import CardContent from '@mui/material/CardContent';
import measurementsIcon from '#component/icon/measurements';
import {
  StyledCard,
  CardHeader,
  CardHeaderText,
  CardIdentifiers
} from '#component/device/overview/styles';

function EventsMobileCard(props) {
  const {
    handleOpen,
    events
  } = props;

  const icon = measurementsIcon('events');
  const EVENTS_TAB = 100;

  const isPresent = events.length;

  return (
    isPresent ?
      <StyledCard>
        <CardContent
          onClick={() => handleOpen(EVENTS_TAB)}
          component={CardHeader}
        >
          <CardIdentifiers>
            {icon}
            EVENTS
          </CardIdentifiers>
          <CardHeaderText>
            {[...events].length}
          </CardHeaderText>
        </CardContent>
      </StyledCard> :
      null
  );
}

export default EventsMobileCard;
